import request from '@/utils/request'

// 查询用户体型图片列表
export function listUserBodyphoto(query) {
    return request({
        url: '/biz/userBodyphoto/list',
        method: 'get',
        params: query
    })
}

// 查询用户体型图片详细
export function getUserBodyphoto(id) {
    return request({
        url: '/biz/userBodyphoto/' + id,
        method: 'get'
    })
}

// 新增用户体型图片
export function addUserBodyphoto(data) {
    return request({
        url: '/biz/userBodyphoto',
        method: 'post',
        data: data
    })
}

// 修改用户体型图片
export function updateUserBodyphoto(data) {
    return request({
        url: '/biz/userBodyphoto/update',
        method: 'post',
        data: data
    })
}

// 删除用户体型图片
export function delUserBodyphoto(id) {
    return request({
        url: '/biz/userBodyphoto/delete/' + id,
        method: 'post'
    })
}
